import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Import Stimulus controllers
import "./controllers"

// Import interactive features
import "./mobile-menu.js"
import "./copy-command.js"

console.info("Bridgetown is loaded!")
